// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Property code:</td>
      <td>
        <select
          ng-model="\$ctrl.input.code"
          ng-options="code as code for code in \$ctrl.editableCodes"
          ng-change="\$ctrl.resetInputValue(\$ctrl.input.code)"
          required>
        </select>
        <help ng-if="\$ctrl.input.code === 'COLLECTION_OFFLINE_FORECAST_DAYS'" title="Number of days in advance the collection app can download from the current system date.
Min: 0, Max: 365. 0 means forecasting is disabled and App will always get the as of date collections"></help>
      </td>
    </tr>
    <tr>
      <td>New property value:</td>
      <td>
        <textarea
          ng-model="\$ctrl.input.value"
          maxlength="512"
          rows="4">
        </textarea>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="submit"
      class=" btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-system-property/update-system-property.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;